module.exports = __webpack_public_path__ + "img/mes-capture-workorder.3071ee99.png";